import { gql } from 'apollo-client-ppc';

export const fetchProductsUnderPPCloudSite = gql`
  query fetchProductsUnderPPCloudSite($cloudSiteUrl: String) {
    productsUnderPPCCloudSite(cloudSiteUrl: $cloudSiteUrl) {
      id
      transactionAccountId
      productCatalogId
      cloudSiteId
      cloudSiteHostname
      invoiceGroupId
      sourceSystem
      relatesFromEntitlements {
        entitlementId
        relationshipType
      }
    }
  }
`;
